import { render } from "./AboutMe.vue?vue&type=template&id=3ed201b7&ts=true"
import script from "./AboutMe.vue?vue&type=script&lang=ts"
export * from "./AboutMe.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__